//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 중대재해처벌법 이행관리 (SER_BASIC) 전용 로직
 * other 케이스에서 사용
 */

// 제목 배열 (val1에 매핑)
const Title = [
  '1.경영자의 안전보건경영활동 (100점)',
  '2.위험성 평가 (100점)',
  '3.안전보건교육 (100점)',
  '4.근로자 참여 (100점)',
  '5.중대재해 대응조치 (100점)',
  '6.도급.용역.위탁 안전보건확보 (100점)',
  '7.평가 및 개선 (100점)',
  '8.안전문화 및 안전의식 (100점)',
  '9.가점 사항 (100점)',
];

// 중대재해처벌법 이행관리 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터
  dispatch,
  setLoading,
  rowData1, // 전체 리스트 (selectedRowData1 대신 사용)
  custInfo, // 사업장 정보 목록
  searchRef
) => {
  setLoading(true);

  let headerData = {};
  let tableData1 = [];

  try {
    // documentData가 배열인 경우 첫 번째 항목 사용
    const selectedItem = Array.isArray(documentData)
      ? documentData[0]
      : documentData;

    if (!selectedItem || !rowData1 || rowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '항목을 선택하세요.',
          type: 'warning',
        })
      );
      return null;
    }

    const result = await apiRequest(
      'post',
      Global.urls.DocsManagement.getSerBasic01R1,
      {
        SdCode: Commons.EncryptAES(selectedItem.sdCode),
      }
    );

    let data = result.data;

    if (data.length === 0) {
      // 데이터 없음
    } else if (data[0]?.type === 'Error') {
      throw new Error(data[0].message);
    } else {
      const cust = custInfo?.find(
        (f) => f.custCd === searchRef?.current?.custCd
      );

      // 평가등급 계산
      const workNo = cust?.workNo || 0; // workNo 값
      const point = data[0]?.evaPoint || 0; // 총 점수
      let evaGrade = '초급'; // 기본값

      if (workNo >= 50 && workNo <= 300) {
        if (point < 400) {
          evaGrade = '초급';
        } else if (point >= 400 && point <= 559) {
          evaGrade = '중급';
        } else {
          evaGrade = '고급';
        }
      } else if (workNo >= 20 && workNo < 50) {
        if (point < 320) {
          evaGrade = '초급';
        } else if (point >= 320 && point <= 479) {
          evaGrade = '중급';
        } else {
          evaGrade = '고급';
        }
      } else if (workNo < 20) {
        if (point < 240) {
          evaGrade = '초급';
        } else if (point >= 240 && point <= 399) {
          evaGrade = '중급';
        } else {
          evaGrade = '고급';
        }
      }

      headerData = {
        ...data[0],
        evaDate: dayjs(selectedItem.evaDate)
          .format('YYYY.MM.DD (dddd)')
          .replace('Monday', '월')
          .replace('Tuesday', '화')
          .replace('Wednesday', '수')
          .replace('Thursday', '목')
          .replace('Friday', '금')
          .replace('Saturday', '토')
          .replace('Sunday', '일'), // 평가일자
        ...cust,
        // industrialSmall: industrialSmall, // 업종명
        workNo: workNo, // 상시근로자수
        evaGrade: evaGrade, // 평가등급
      };
    }

    // SP_SER_BASIC_01_R2: 테이블 데이터 조회
    const result2 = await apiRequest(
      'post',
      Global.urls.DocsManagement.getSerBasic01R2,
      {
        SdCode: Commons.EncryptAES(selectedItem.sdCode),
      }
    );

    let data2 = result2.data;

    if (data2.length === 0) {
      // 데이터 없음
    } else if (data2[0]?.type === 'Error') {
      dispatch(
        showSnackbar({
          message: data2[0].message,
          type: 'error',
        })
      );
      return false;
    } else {
      // val1과 groupCd 기준으로 no 생성
      let currentVal1 = null;
      let currentGroupCd = null;
      let subNumber = 1;

      data2.forEach((item, index) => {
        item.title = Title[item.val1 - 1]; // 제목 매핑
        item.evaluation = // 평가 매핑
          item.checkYn === 'Y'
            ? '적정'
            : item.checkYn === 'N'
              ? '미흡'
              : item.checkYn === '0'
                ? '해당없음'
                : item.checkYn;

        // 점수 계산
        // checkYn이 Y 또는 0인 경우 score 계산
        if (item.checkYn === 'Y' || item.checkYn === '0') {
          // 같은 groupCd의 총 갯수 계산
          const sameGroupCount = data2.filter(
            (d) => d.groupCd === item.groupCd
          ).length;

          // score = (같은 val2 / groupCd의 갯수)
          item.score = item.val2 / sameGroupCount;
        } else {
          item.score = 0;
        }

        // 착안사항
        item.seriousDisasterNm =
          item.seriousDisaster.slice(-1) + '. ' + item.seriousDisasterNm; // 앞에 숫자 붙이기

        // 번호
        if (currentVal1 !== item.val1) {
          // val1이 바뀔 때 subNumber 초기화
          currentVal1 = item.val1;
          subNumber = 1;
        } else if (currentGroupCd !== item.groupCd) {
          // groupCd가 바뀔 때 subNumber 증가
          subNumber++;
        }

        currentGroupCd = item.groupCd;
        item.no = `${item.val1}.${subNumber}`;
      });

      tableData1 = data2;
    }

    const printData = {
      FileName: 'SER_BASIC',
      HeaderData: JSON.stringify(headerData),
      TableData1: JSON.stringify(tableData1),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 데이터 생성에 실패했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
